import { DriveFile } from "../entities/drive-file";

export abstract class GraphRepository {
   public abstract getSearchResult(queryText: string, rowLimit: number, requestReference): Promise<DriveFile[]>
}